/* ============================================================
   MENGENSTAFFELN · Lieblingscap
   Reines Vanilla JS, keine Abhaengigkeiten. Rechnet NICHTS neu, was
   nicht schon in den data-config-Zahlen aus dem Liquid-Teil steht -
   die eigentliche Preisberechnung passiert serverseitig in
   mengenstaffeln.liquid. Hier nur: Zeilen zeichnen, aktive Stufe
   markieren, echtes Mengenfeld setzen/beobachten.
   ============================================================ */
(function () {
  'use strict';

  function initMS(root) {
    if (root.dataset.msInit) return;
    root.dataset.msInit = '1';

    var CFG = JSON.parse(root.dataset.config);
    var staffeln = (CFG.staffeln || []).slice().sort(function (a, b) { return a.menge - b.menge; });
    if (!staffeln.length) return;

    var mengeInput = document.getElementById(root.dataset.quantityInputId);
    if (!mengeInput) return;

    var elZeilen = root.querySelector('.ms__zeilen');
    var elPreis = root.querySelector('.ms__preis-je-stueck');
    var elGesamt = root.querySelector('.ms__gesamt');

    var geld = null;
    try {
      geld = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: CFG.waehrung || 'EUR'
      });
    } catch (e) { geld = null; }
    function preisText(cent) {
      var betrag = cent / 100;
      return geld ? geld.format(betrag) : betrag.toFixed(2).replace('.', ',') + ' €';
    }

    /* Aktive Stufe: die HOECHSTE Staffel, deren "menge" die aktuelle
       Eingabe nicht uebersteigt - genau das Prinzip echter
       Shopify-Mengenrabatte ("ab X Stueck"). Liegt die Eingabe unter
       der kleinsten Stufe, gilt der normale Grundpreis (erste Stufe
       mit 0% wird ueblicherweise ohnehin die kleinste sein). */
    function aktiveStaffel(menge) {
      var treffer = null;
      staffeln.forEach(function (s) {
        if (menge >= s.menge) treffer = s;
      });
      return treffer;
    }

    function zeichneZeilen() {
      var aktuelleMenge = parseInt(mengeInput.value, 10) || 0;
      var aktiv = aktiveStaffel(aktuelleMenge);

      elZeilen.innerHTML = '';
      staffeln.forEach(function (s) {
        var zeile = document.createElement('button');
        zeile.type = 'button';
        zeile.className = 'ms__zeile';
        zeile.setAttribute('aria-pressed', aktiv === s);

        var mengeSpan = document.createElement('span');
        mengeSpan.className = 'ms__zeile-menge';
        mengeSpan.textContent = s.menge + ' Stück';

        var preisSpan = document.createElement('span');
        preisSpan.className = 'ms__zeile-preis';
        preisSpan.textContent = preisText(s.proStueck) + ' / Stück';

        var rechts = document.createElement('span');
        rechts.className = 'ms__zeile-rechts';
        if (s.prozent > 0) {
          var badge = document.createElement('span');
          badge.className = 'ms__badge';
          badge.textContent = '−' + s.prozent + ' %';
          rechts.appendChild(badge);
        }
        var gesamtSpan = document.createElement('span');
        gesamtSpan.className = 'ms__zeile-gesamt';
        gesamtSpan.textContent = preisText(s.gesamt);
        rechts.appendChild(gesamtSpan);

        zeile.appendChild(mengeSpan);
        zeile.appendChild(preisSpan);
        zeile.appendChild(rechts);

        zeile.addEventListener('click', function () {
          mengeInput.value = s.menge;
          mengeInput.dispatchEvent(new Event('change', { bubbles: true }));
          mengeInput.dispatchEvent(new Event('input', { bubbles: true }));
          zeichneAlles();
        });

        elZeilen.appendChild(zeile);
      });
    }

    function zeichneKopf() {
      var aktuelleMenge = parseInt(mengeInput.value, 10) || 0;
      var aktiv = aktiveStaffel(aktuelleMenge);
      if (aktiv) {
        elPreis.textContent = preisText(aktiv.proStueck) + ' / Stück';
        elGesamt.textContent = 'Gesamt ' + preisText(aktiv.proStueck * aktuelleMenge);
      } else {
        elPreis.textContent = preisText(CFG.basisPreis) + ' / Stück';
        elGesamt.textContent = 'Gesamt ' + preisText(CFG.basisPreis * (aktuelleMenge || 1));
      }
    }

    function zeichneAlles() {
      zeichneZeilen();
      zeichneKopf();
    }

    ['input', 'change'].forEach(function (art) {
      mengeInput.addEventListener(art, zeichneAlles);
    });

    zeichneAlles();
  }

  function boot() {
    document.querySelectorAll('.ms').forEach(initMS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('.ms') : null;
    if (el) initMS(el);
  });
})();
